<div>
    <div class="row">
        <div class="col-8">
            <h1><i class="fas fa-search-dollar"></i> Pesquisa de PACs </h1>
        </div>
        <div class="col-4 d-flex justify-content-end align-items-center">
            <button class="btn btn-sm btn-outline-primary me-1" (click)="filtro()" type="button">
                <i class="fa fa-search-minus me-1" aria-hidden="true" *ngIf="abrirFiltro"></i>
                <i class="fa fa-search-plus me-1" aria-hidden="true" *ngIf="!abrirFiltro"></i>
                Filtro
            </button>
            <h4 *ngIf='dataUser?.login != ""' class="m-0 !important;"><span class='badge bg-primary'> {{dataUser?.login}} </span></h4>
        </div>
    </div>

    <div class="row py-2">
        <div class="col-3">
            <label>Proposta</label>
            <div class="editarFormGroup d-flex">
                <div class="col-6 ps-0">
                    <input
                        class="form-control"
                        type="text"
                        placeholder="Número"
                        [(ngModel)]="filtroPesquisa.proposta"
                        maxlength=8
                        name="numeroProposta"
                    />
                </div>
                <div class="align-items-center d-flex">/</div>
                <div class="col-6">
                    <input
                        class="form-control"
                        placeholder="Ano"
                        [(ngModel)]="filtroPesquisa.dataProposta"
                        bnMask="INTEIRO"
                        maxlength=4
                        name="anoProposta"
                    />
                </div>
            </div>
        </div>
        <div class="col-3">
            <label>PAC</label>
            <div class="editarFormGroup d-flex">
                <div class="col-6 ps-0">
                    <input
                        class="form-control"
                        placeholder="Número"
                        [(ngModel)]="filtroPesquisa.numeroPAC"
                        bnMask="99.999-9"
                        name="numeroPAC"
                    />
                </div>
                <div class="align-items-center d-flex">/</div>
                <div class="col-6">
                    <input
                        class="form-control"
                        placeholder="Ano"
                        [(ngModel)]="filtroPesquisa.aprovacao"
                        bnMask="INTEIRO"
                        maxlength=4
                        name="anoPAC"
                    />
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="abrirFiltro">
        <div class="row py-2">

            <div class="bn-form-group col-3" *ngIf="isUsuarioBndes || isAuditorBndes">
                <label>Documento</label>
                <input
                    class="form-control"
                    placeholder="Número do Documento"
                    [(ngModel)]="filtroPesquisa.documento"
                    bnMask="999999999999"
                    maxlength=12
                    name="pesquisaDocumento"
                />
            </div>

            <div class="bn-form-group col-5">
                <label>Programa</label>
                <select class="form-control selectpicker" data-live-search="true" [(ngModel)]="programaFiltrado">
                    <option value='undefined' selected></option>
                    <option *ngFor="let programa of programaList" value="{{programa.id}}"> {{programa.nomeProgramaSubPrograma}}</option>
                </select>
            </div>
        </div>

        <div class="row py-2">
            <div class="col-4">
                <label>Beneficiária</label>
                <input
                    class="form-control"
                    placeholder="CPF, CNPJ, Razão Social ou Nome"
                    [(ngModel)]="filtroPesquisa.comprador"
                    name="pesquisaBeneficiaria"
                />
            </div>
            <div class="bn-form-group col-4">
                <label>Fabricante</label>
                <input
                    class="form-control"
                    placeholder="CNPJ ou Razão Social"
                    [(ngModel)]="filtroPesquisa.fabricante"
                    name="pesquisaFabricante"
                />
            </div>
        </div>

        <div class="row py-2">

            <div class="bn-form-group col-5" *ngIf="isUsuarioBndes || isAuditorBndes">
                <label>Agente Financeiro</label>
                <input list="listaAgentes" name="agente" class="form-control selectpicker" [(ngModel)]="cnpjAgenteFinaceiroFiltrado">
                <datalist id="listaAgentes">
                    <option value='' selected></option>
                    <option *ngFor="let agente of agenteFinanceiroList" value="{{agente.nome}} - {{agente.sigla}} - {{agente.cnpj | bnMask: 'CNPJ'}} "></option>
                </datalist >
            </div>
        </div>
    </div>

    <div class="row pb-3">
        <div class="d-flex col-12 justify-content-end">
            <button class="btn btn-primary" (click)="pesquisar()" type="submit">
                <i class="fa fa-search me-1" aria-hidden="true"></i>
                Pesquisar
            </button>
        </div>
    </div>

        <bn-paginacao
            [total]="paginacao.itens.length"
            [tamanhoPagina]="paginacao.parametros.pageSize"
            [numPagina]="paginacao.parametros.page"
            [opcoesTamanhoPagina]="paginacao.tamanhosPagina"
            (aoMudar)="paginacao.aoMudar($event)" class="w-100">

            <table class="table table-hover table-sm" aria-describedby="Lista Proposta">
                <thead>
                    <tr style="font-size: 14px;" class="text-center">
                        <th scope="col">
                            <bn-ordenacao
                                [ordenacao]="atributosOrdenacao"
                                [atributo]="'proposta'"
                                [nomeAtributoExibicao]="labelTabela[0]"
                                [sentidoInicial]="'asc'"
                                (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>
                        <th scope="col">
                            <bn-ordenacao
                                [ordenacao]="atributosOrdenacao"
                                [atributo]="'numeroPAC'"
                                [nomeAtributoExibicao]="labelTabela[1]"
                                (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>
                        <th scope="col">
                            <bn-ordenacao
                                [ordenacao]="atributosOrdenacao"
                                [atributo]="'comprador'"
                                [nomeAtributoExibicao]="labelTabela[2]"
                                (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>
                        <th scope="col" *ngIf="isUsuarioBndes || isAuditorBndes">
                            <bn-ordenacao
                                [ordenacao]="atributosOrdenacao"
                                [atributo]="'agenteFinanceiro'"
                                [nomeAtributoExibicao]="labelTabela[3]"
                                (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>
                        <th scope="col">
                            <bn-ordenacao
                                [ordenacao]="atributosOrdenacao"
                                [atributo]="'aprovacao'"
                                [nomeAtributoExibicao]="labelTabela[5]"
                                (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>
                        <th scope="col">
                            <bn-ordenacao
                                [ordenacao]="atributosOrdenacao"
                                [atributo]="'valor'"
                                [nomeAtributoExibicao]="labelTabela[6]"
                                (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>
                        <th scope="col" *ngIf="isUsuarioBndes || isAuditorBndes">
                            <bn-ordenacao
                                [ordenacao]="atributosOrdenacao"
                                [atributo]="'fabricante'"
                                [nomeAtributoExibicao]="labelTabela[7]"
                                (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>
                        <th scope="col">
                            <bn-ordenacao
                                [ordenacao]="atributosOrdenacao"
                                [atributo]="'situacao'"
                                [nomeAtributoExibicao]="labelTabela[8]"
                                (aoClickar)="mudancaOrdenacao($event)">
                            </bn-ordenacao>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="clickable text-center" *ngFor="let item of paginacao.itensPagina" bn-long-press (click)="consultarProposta(item)" style="font-size: 13px;">
                        <td>{{item.proposta}}/{{item.dataProposta}}</td>
                        <td><strong>{{item.numeroPAC | bnMask:'99.999-9'}}</strong></td>
                        <td>{{item.comprador}}</td>
                        <td *ngIf="item.siglaAgenteFinanceiro == null && ( isUsuarioBndes || isAuditorBndes )">{{item.codAgenteFinanceiro}}</td>
                        <td *ngIf="item.siglaAgenteFinanceiro != null && ( isUsuarioBndes || isAuditorBndes )">{{item.codAgenteFinanceiro}}-{{item.siglaAgenteFinanceiro}}</td>
                        <td>{{item.aprovacao | date: 'dd/MM/yyyy'}}</td>
                        <td>R$ {{item.valor | bnMask:'MOEDA'}}</td>
                        <td *ngIf="isUsuarioBndes || isAuditorBndes">
                            <ul class="list-group" style="padding-left: 40px; align-items: flex-start;">
                                <li *ngFor="let fabricante of buscarFabricantes(item)">{{fabricante}}</li>
                            </ul>
                        </td>
                        <td><span [ngClass] = "getStyleSituacao(item)">{{item.situacao}}</span></td>
                    </tr>
                </tbody>
            </table>
        </bn-paginacao>
</div>
